<!-- <div class="listing-page">
    <div class="content-section-port">
        <h1>
            <em>
                <strong>

                    CASE STUDIES

                </strong>
                <svg class="nectar-scribble basic-underline" viewBox="-400 -55 730 60" preserveAspectRatio="none"><path style="animation-duration: 1.3s;" d="m -383.25 -6 c 55.25 -22 130.75 -33.5 293.25 -38 c 54.5 -0.5 195 -2.5 401 15" stroke="#ffffff" pathLength="1" stroke-width="8" fill="none"></path></svg>
            </em>
        </h1>
    </div>
    <!-- <img src="https://sandbox.elemisthemes.com/assets/img/photos/bg11.jpg" alt=""> 
    
</div>
<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 reveal active">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/andre-benz-MsMISAIe8Qw-unsplash%20(1).jpg?alt=media&token=01cdb556-0e32-44c8-922b-0cd4d2dbc19e">
                    <h2 class="card-title">Cynthia Rowley</h2>
                    <p class="card-text">Cynthia Rowley is a leading global provider of fashion and trendy clothes. The brand anticipates the taste of its customers and makes the best signature clothes for them. Cynthia Rowley’s main motto is rooted in empowering women. </p>
                </div>
            </div>
            <div class="col-md-6 reveal right active">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/andre-benz-MsMISAIe8Qw-unsplash%20(1).jpg?alt=media&token=01cdb556-0e32-44c8-922b-0cd4d2dbc19e">
                    <h2 class="card-title">Lockwood Umbrellas</h2>
                    <p class="card-text">The Lockwood Umbrellas is an e-commerce business website, that mainly focuses on selling the finest quality umbrellas. Lockwood Umbrellas is from the UK (London).selling premium quality customized and non-customized umbrellas to its customers.
                    </p>
                </div>
            </div>
            <div class="col-md-6 reveal">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/love-bonito.jpg?alt=media&token=15ec55c3-9623-421a-b210-ceec0c6b7835">
                    <h2 class="card-title">Love Bonito</h2>
                    <p class="card-text">Love Bonito is one of the top Singapore online fashion labels with an engaging presence across the Asia-Pacific region. Love Bonito was founded in the year 2010 and since then spreading its business not only in Asia but also in countries like the USA.</p>
                </div>
            </div>
            <div class="col-md-6 reveal right">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/202315232349-36slide11-3.jpg?alt=media&token=2137a9b6-0277-4d87-a414-33acabb44b00">
                    <h2 class="card-title">iLastword</h2>
                    <p class="card-text">iLastword became the first online portal where people can write about their loved ones after they passed away or can
                         give tribute to their loved ones who are in critical condition. Where the person who is ill can post something about their journey into this world and can publish it on their own or can make a nominee to publish it and handle the account.</p>
                </div>
            </div>
            <div class="col-md-6 reveal">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/girl-with-dog.jpg?alt=media&token=bc16fea4-7904-4504-8e04-579e87997576">
                    <h2 class="card-title">Pets and Joys</h2>
                    <p class="card-text"></p>
                    The main motto behind the Pets and Joys application is to make pets live healthy, safe, and happy lives. Pets and Joys is an application for pets to relish the life of pet owners. The application allows pet owners to schedule an appointment with the veterinarian, order pet food, and manage all the information about their pets. Also, via this application vets can suggest and add medication and prescriptions for pets if they want to. </div>
            </div>
            <div class="col-md-6 reveal right">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/still-life-care-products_23-2149371308.webp?alt=media&token=a1eb6bd3-0150-448b-b5b3-000b9eefc5a7">
                    <h2 class="card-title">The Body Shop</h2>
                    <p class="card-text">The Body Shop is a cosmetic brand, known to sell cruelty-free products around the world. It is the one-stop destination for all women looking for skincare, haircare, bath, and body products. The Body Shop is in the business for the last 40 years and still smashing beauty spectrum standards to their top level. </p>
                </div>
            </div>

            <div class="col-md-6 reveal">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/male-female-business-people-working-tablet-office.jpg?alt=media&token=da3b56a0-479d-4e38-817d-15940245ddd8">
                    <h2 class="card-title">ZonSteps</h2>
                    <p class="card-text">Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time image of your Amazon business to optimize it and progress you toward a successful journey.</p>
                </div>
            </div>
            <div class="col-md-6 reveal right">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/male-female-business-people-working-tablet-office.jpg?alt=media&token=da3b56a0-479d-4e38-817d-15940245ddd8">
                    <h2 class="card-title">ZonSteps</h2>
                    <p class="card-text">Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time image of your Amazon business to optimize it and progress you toward a successful journey.</p>
                </div>
            </div>
            <div class="col-md-6 reveal">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/male-female-business-people-working-tablet-office.jpg?alt=media&token=da3b56a0-479d-4e38-817d-15940245ddd8">
                    <h2 class="card-title">ZonSteps</h2>
                    <p class="card-text">Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time image of your Amazon business to optimize it and progress you toward a successful journey.</p>
                </div>
            </div>
            <div class="col-md-6 reveal right">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/male-female-business-people-working-tablet-office.jpg?alt=media&token=da3b56a0-479d-4e38-817d-15940245ddd8">
                    <h2 class="card-title">ZonSteps</h2>
                    <p class="card-text">Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time image of your Amazon business to optimize it and progress you toward a successful journey.</p>
                </div>
            </div>
            <div class="col-md-6 reveal">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/male-female-business-people-working-tablet-office.jpg?alt=media&token=da3b56a0-479d-4e38-817d-15940245ddd8">
                    <h2 class="card-title">ZonSteps</h2>
                    <p class="card-text">Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time image of your Amazon business to optimize it and progress you toward a successful journey.</p>
                </div>
            </div>
            <div class="col-md-6 reveal right">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/male-female-business-people-working-tablet-office.jpg?alt=media&token=da3b56a0-479d-4e38-817d-15940245ddd8">
                    <h2 class="card-title">ZonSteps</h2>
                    <p class="card-text">Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time image of your Amazon business to optimize it and progress you toward a successful journey.</p>
                </div>
            </div>
            <div class="col-md-6 reveal">
                <div class="card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/male-female-business-people-working-tablet-office.jpg?alt=media&token=da3b56a0-479d-4e38-817d-15940245ddd8">
                    <h2 class="card-title">ZonSteps</h2>
                    <p class="card-text">Simplify the journey of your business with ZonSteps. It is the step-by-step guide system to set up, launch, and grow your profitable FBA business. ZonSteps is designed to give you a real-time image of your Amazon business to optimize it and progress you toward a successful journey.</p>
                </div>
            </div>
        </div>
    </div>
</section> -->





<div class="listing-page">
    <div class="content-section-port">
        <h1>
            <em>
                <strong>
                    Success Stories
                </strong>
                <svg class="nectar-scribble basic-underline" viewBox="-400 -55 730 60" preserveAspectRatio="none"><path style="animation-duration: 1.3s;" d="m -383.25 -6 c 55.25 -22 130.75 -33.5 293.25 -38 c 54.5 -0.5 195 -2.5 401 15" stroke="#ffffff" pathLength="1" stroke-width="8" fill="none"></path></svg>
            </em>
            that speak for Themselves
        </h1>
    </div>
    <!-- <img src="https://sandbox.elemisthemes.com/assets/img/photos/bg11.jpg" alt=""> -->
    
</div>
<div class="portfolio-listing-box">
    <h6>Case Studies</h6>

    
  
<div class="list-item-port" data-post-id="11181" data-has-img="true" *ngFor="let arr of array" >    
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" routerLink="/{{arr.websitelink}}" target="_blank"  title="view website" ></a>
                    <!-- <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="{{arr.img1}}"> -->
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src={{arr.img}} alt="{{arr.name}}" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                   
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">    {{ arr.nameprint}}</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">{{arr.infosub}}
                    </a>
                </span>

                <a class="view-btn-value">View</a>
            </div>
        </div>
    </div>

<!-- 
    <div class="list-item-port" data-post-id="11181" data-has-img="true"  *ngFor="let arr of array"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" href="{{arr.websitelink}} " target="_blank"  title="view-website"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="{{arr.img1}}">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="{{arr.img}}" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">
                    {{arr.nameprint}}
                    </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">{{arr.infosub}} </a>
                </span>
            </div>
        </div>
    </div>  -->


<!--     
    <div class="list-item-port" data-post-id="11181" data-has-img="true">    
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Cynthia')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Cynthiarowley.jpg?alt=media&token=bb989c30-3fdd-4dff-b9d7-5d369b181c19">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Cynthiarowley-Banner.jpg?alt=media&token=21fc2ff1-8d1d-48e3-ab9e-084a3fa59259" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Cynthia Rowley </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce & Retail
                    </a>
                </span>
            </div>
        </div>
    </div> -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS"  (click)="navigate('lockwood')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Lockwoodumbrellas.jpg?alt=media&token=6a3ab76b-6d01-4fc9-bc53-4edb8f79178f">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/lockwoodumbrellas-Banner.jpg?alt=media&token=5ee3dfd9-3c7e-411a-9914-c564e90816e1" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Lockwood Umbrellas</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce & Retail </a>
                </span>
            </div>
        </div>
    </div> -->

    
    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Love-Bonito')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Love%20Bonito.jpg?alt=media&token=42ad02c7-9ba8-4dcb-a467-d550904bf004">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Love-Bonito.jpg?alt=media&token=139c6df8-b0ca-4781-9a16-3789d9c01b69" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Love Bonito</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Ecommerce & Retail, Apparels & Fashion</a>
                </span>
            </div>
        </div>
    </div> -->
    
    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('iLastWord')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/ilastwordmobileportfolio.jpg?alt=media&token=54713c6d-1639-4f8a-aeb0-ada69bafc412">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/ilastword-desktop.jpg?alt=media&token=9774d49d-aec9-4915-bb70-62b06fd671ed" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">iLastWord </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div> -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('PetandJoys')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Pets%20%26%20Joys.jpg?alt=media&token=359ff6bd-5916-4117-8d2c-ae314e45cc27">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Pets-%26-Joys.jpg?alt=media&token=44e29f28-ecf7-47ac-bc00-335fa00bddca" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Pets & Joys </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Animal Welfare
                    </a>
                </span>
            </div>
        </div>
    </div> -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('bodyshop')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Thebodyshop.jpg?alt=media&token=9e23eb70-0598-4510-bfd8-694153bede0c">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Thebodyshop-Banner.jpg?alt=media&token=2476b826-efac-47de-87f1-293ae3d281a3" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">The Body Shop </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-Commerce
                    </a>
                </span>
            </div>
        </div>
    </div> -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Zonsteps')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Mobile-Zonsteps.jpg?alt=media&token=9b3ea64b-669e-49b3-82f4-c30aa0990079">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Zonsteps.jpg?alt=media&token=b705e019-9776-434e-bd5a-37ef913fc39c" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">ZonSteps </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business
                    </a>
                </span>
            </div>

       
     

        </div>
    </div> -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Threndx')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/threndx-mobile.jpg?alt=media&token=24ec5020-dbe9-4286-a3ff-2f6ec7ece5e0">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/threndx-desktop.jpg?alt=media&token=69c708b9-134a-42b8-be47-99b465874f79" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Threndx </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Social Media Platform
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>    -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('H&M')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/H%26M-Mobile-view-'.jpg?alt=media&token=108b70a1-f031-4aa0-8174-97338a6f26f7">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/H%26M-desktop.jpg?alt=media&token=5d984e36-5255-4802-8c71-d3168534d800" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">H&M </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>    -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Style Flip')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/styleflip-mobile-view.jpg?alt=media&token=f9b81f3c-57ca-49ba-a896-16d814073936">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/styleflip-desktop-view.jpg?alt=media&token=17c93b03-e2c6-4a8c-847c-b629e9f727fc" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Style Flip </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>    -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Marc Fisher')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Marc-ficher-mobile-view.jpg?alt=media&token=954c9fa4-c4ff-4f5e-8ab7-9c38f54498ae">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Marc-ficher-desktop-view.jpg?alt=media&token=1e3a4837-787e-49b6-8487-471f2f70fb95" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Marc Fisher </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>   -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Rungg Shoes')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Rungg%20shoes%20mobile%20view.png?alt=media&token=649a9fba-60d4-4952-9ef2-914abc5b9861">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Rungg%20shoes.jpg?alt=media&token=315e4a37-6ea1-470e-82cf-b45a027a3572" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Rungg Shoes </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>   -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Ramy Brook')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Rammy%20brook%20mobile%20view.jpg?alt=media&token=69aa02bb-bf49-4ac0-a769-3dffb5cb33a7">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Ramy%20brook.jpg?alt=media&token=eecbe70a-2d53-4856-a49f-9f7b9fa15f56" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Ramy Brook</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>   -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Vans')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/vans%20mobile%20view.png?alt=media&token=31b8a5fe-f39a-4060-b0d1-6b374872168e">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/portfolio-vans.png?alt=media&token=ff85bd41-545f-4285-ab92-a70b734ce726" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Vans</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>   -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Vital Print Press')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Vital%20print%20press%20mobile%20view.png?alt=media&token=4d33cc5a-6feb-4e1b-a3b5-7cf454e20382">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Vital%20prints%20desktop.png?alt=media&token=7d112000-4b1c-4c94-b3db-1b822015276a" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Vital Print Press</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('All Pro Color')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/All-Pro-Color-mobile%20view.png?alt=media&token=83f5b1d9-91a3-43cc-a0be-c865f82395d1">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/all%20pro%20color%20desktop.jpg?alt=media&token=6822a4ca-bca4-4b47-9161-a6259cbbf885" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">All Pro Color</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

<!-- 
    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('The Home Entrepreneurs')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Home%20entreprenures%20mobile%20img.png?alt=media&token=b9d6b232-7816-480c-b6e1-5f2938b71504">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Home%20entreprenures%20desktop%20img.png?alt=media&token=ce9620d9-a1bc-4f2e-adb3-b2352660b346" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">The Home Entrepreneurs</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('4 Cabling')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/4%20Cabling%20mobile%20view.png?alt=media&token=4bb7cb11-154c-4f50-993d-9bf7e65d1d63">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/4%20Cabling%20desktop%20view.png?alt=media&token=bef9d04d-8b23-434c-9eb2-dc8e077f8446" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">4 Cabling</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('BODYARMOR')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Bodyarmor-mobile-view.jpg?alt=media&token=8abc604a-a254-45e9-898d-57eb17f0f970">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Bodyarmor-desktop-view.jpg?alt=media&token=35e92e80-3fd0-4b46-9eb1-bbe2af893a77" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">BODYARMOR</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Polofactory')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/polofactory-mobile-view.jpg?alt=media&token=00504bae-6262-4cb5-bdb2-0990afe88d65">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/polofactory-desktop-view.jpg?alt=media&token=70cacd15-be47-4bdc-a739-aa459b5cb71f" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Polofactory</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Calvin Klein Korea')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Calvin-klein-mobile-view.jpg?alt=media&token=1c2d1f5a-2317-4421-9eea-d47f3af8981c">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Calvin-klein-desktop-view.jpg?alt=media&token=8e6a5a4d-4971-4229-9932-a87cf8b658ae" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Calvin Klein Korea</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Supply Ok')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/supply-ok-mobile-view.jpg?alt=media&token=d0c64aba-6514-42f0-87d7-d1de6e6a4c27">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/supply-ok-desktop-view.jpg?alt=media&token=6e2155dd-5a85-4b6e-a4ac-5232065f4c87" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Supply Ok</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->



    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Gift Wrap')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Giftwrap-mobile-view.jpg?alt=media&token=be2b507b-58ec-4b3d-9f09-e92f9e983fad">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Giftwrap-desktop-view.jpg?alt=media&token=cb793052-0f6f-434c-867e-a35620bdef89" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Gift Wrap</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('pen palace')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Pan-palace-mobile-view.jpg?alt=media&token=485f64b9-9e34-4cf9-b89b-8b06135d9acc">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Pen-palace-desktop-view.jpg?alt=media&token=59347fe5-2a1e-4814-8741-c9496d0377fb" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">pen palace</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Bamboo Nature')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Bambo-nature-mobbile-view.jpg?alt=media&token=60f93748-df3c-43b6-a6ae-4ca5b41ee5ad">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Bambo-nature-desktop-view.jpg?alt=media&token=47acab47-f58f-47f5-9b30-5cb7a8a49406" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Bamboo Nature</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Voylla')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/voylla-mobile-view.jpg?alt=media&token=d3bb3b00-cbfa-4006-ba56-33bc6992a336">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/voylla-desktop-view.jpg?alt=media&token=031d3fc9-7e98-4c44-b27b-1a1a3d76712c" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Voylla</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->
    
    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Neemli Naturals')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Pan-palace-mobile-view.jpg?alt=media&token=485f64b9-9e34-4cf9-b89b-8b06135d9acc">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/neemli-naturals-desktop-view.jpg?alt=media&token=6c00830c-c7d7-4840-9fd1-c81033ec0864" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Neemli Naturals</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('TrueBrowns')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/All-Pro-Color-Recovered.jpg?alt=media&token=57101e76-20c9-439d-9607-c3015ddd1c6d">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Truebrowns2-desktop-view.jpg?alt=media&token=19eab376-0d05-477d-a062-bee18cc2555c"  style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">TrueBrowns</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->
   
    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('TrueBrowns USA')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/All-Pro-Color-Recovered(3).jpg?alt=media&token=e4914882-6c0b-4ca0-804c-f0742fdd909e">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/True-browns-desktop-view.jpg?alt=media&token=411d8323-482c-403d-aaa9-f61747d06dee" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">TrueBrowns USA</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Break Bounce')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/All-Pro-Color-Recovered(2).jpg?alt=media&token=47135e66-41d5-4d87-a938-3a5f0e76de73">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/desktop(2).jpg?alt=media&token=5d278497-24b3-44fb-b1a8-8a782a3f12c0" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Break Bounce</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>
        </div>
    </div> 
 -->

    

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('The Label Life')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/label%20life%20UAE%20MOBILE-VIEW.png?alt=media&token=41786771-eaa2-4b07-b9ac-5d4f89a5a3d0">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/LABEL%20LIFE%20UAE%20DESKTOP%20VIEW.png?alt=media&token=cb9e5df2-d13e-4169-ad18-f19838fcaf89" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">The Label Life</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('The Label Life UAE')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/label%20life%20mobile-view.png?alt=media&token=8defc717-e96b-46d8-9dfa-4535079dc64a">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/LABEL%20LIFE%20DESKTOP.png?alt=media&token=df0a8d15-58e2-4f5d-a948-18a870d36c5a" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">The Label Life UAE</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Abhishti')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/All-Pro-Color-Recovered(2).jpg?alt=media&token=47135e66-41d5-4d87-a938-3a5f0e76de73">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/EN%20PLIEN%20DESKTOP%20VIEW.png?alt=media&token=392f51a2-6fcb-49fb-9170-48707011213a" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Abhishti</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Doggie Dabbas')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/DOGGIE%20MOBILE%20VIEW.jpg?alt=media&token=3aa60ce4-893e-43d9-90e5-a45fc6b23dab">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/DOGGIE%20DESKTOP%20VIEW.jpg?alt=media&token=707d2e31-482b-42bd-aa55-6b72e979bcf0" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Doggie Dabbas</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->


    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Frangipani')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/KIDS%20MOBILE%20VIEW.png?alt=media&token=d77a1e75-aa2e-4c10-801f-831e00256aae">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/KIDS%20DESKTOP%20VIEW.png?alt=media&token=5c50f43b-f206-4cbf-92fe-1f41aeff57cd" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Frangipani</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Pepe Jeans')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/PEPE%20JEANS%20MOBILE%20VIEW.png?alt=media&token=b3ce44e3-077d-42d6-b2ed-317e73a951cd">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/JEANS%20DESKTOP.png?alt=media&token=93835879-d55a-43fb-bf4d-6c1aaab46e3a" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Pepe Jeans</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">E-commerce
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>  -->

    <!-- <div class="pagination-style">
        <a href="#"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
        <a href="#"><i class="fa fa-angle-left" aria-hidden="true"></i></a>
        <a href="#" class="selected">1</a>
        <a href="#">2</a>
        <a href="#">3</a>
        <p>
            <i class="fa fa-circle" aria-hidden="true"></i>
            <i class="fa fa-circle" aria-hidden="true"></i>
            <i class="fa fa-circle" aria-hidden="true"></i>
            <i class="fa fa-circle" aria-hidden="true"></i>
        </p>
        <a href="#">4</a>
        <a href="#"><i class="fa fa-angle-right" aria-hidden="true"></i></a>
        <a href="#"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
    </div> -->




<!-- 
    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate('Threndx')"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/threndx-mobile.jpg?alt=media&token=24ec5020-dbe9-4286-a3ff-2f6ec7ece5e0">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/threndx-desktop.jpg?alt=media&token=69c708b9-134a-42b8-be47-99b465874f79" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span style="text-transform: none;">Threndx </span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Social Media
                    </a>
                </span>
            </div>

       
     

        </div>
    </div>   -->
    <!-- <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate(1)"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/4%20Cabling.jpg?alt=media&token=c9c1f345-e2f7-47b7-bb91-fe30780663f2">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/4cabling-Banner.jpg?alt=media&token=413038eb-49a4-45f4-afab-87dbdadeef53" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Cabling</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>
    
    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" (click)="navigate(3)" ></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Drinkbodyarwor.jpg?alt=media&token=aeeb8e3a-5a42-409c-9543-ea3d5dea0733">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Drinkbodyarmor-Banner.jpg?alt=media&token=f782d072-6621-4c06-ad7b-2055ef0d96fc" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Bodyarmor Sports Drink</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>

    

    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS"  (click)="navigate(5)"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Marcfisherfootwear.jpg?alt=media&token=3a03ae71-a201-4d96-a613-1798d493ab83">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Marcfisherfootwear-Banner.jpg?alt=media&token=b1a03534-1af1-4845-a356-88ce3378abc1" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Marc Fisher Women</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>

    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS"  (click)="navigate(6)"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Neemlinaturals.jpg?alt=media&token=60741c12-2beb-4c15-b776-7dafc89bb6ac">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Neemlinaturals-Banner.jpg?alt=media&token=8caf74e4-7f6d-49f7-a8ff-ff90c771dcfd" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Neemli Naturals</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>

    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" href="#"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Ramybrook.jpg?alt=media&token=508cdf0e-f1b8-4dfd-a7d4-fa95b03d03c2">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Ramybrook-Banner.jpg?alt=media&token=392691ee-004c-482e-9786-074311c87b49" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Ramy Brook</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>

    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" href="#"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Runggshoes.jpg?alt=media&token=1d1f71b0-1884-40d1-89d5-e062097b22e5">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Runggshoes-Banner.jpg?alt=media&token=2a07d5b0-6d1f-4c57-8ebb-5a7f8dbd89d3" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Rungg Shoepss</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>
    
    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" href="#"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Styleflip.jpg?alt=media&token=28136fb4-3932-450c-b54d-63ddf3c6f8ee">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Styleflip-Banner.jpg?alt=media&token=28602dcd-e2f1-4981-b971-24899ba34f4b" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Style Flip</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>

    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" href="#"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Thebodyshop.jpg?alt=media&token=9e23eb70-0598-4510-bfd8-694153bede0c">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Thebodyshop-Banner.jpg?alt=media&token=2476b826-efac-47de-87f1-293ae3d281a3" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>The Body Shop</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>

    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" href="#"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Thehomeentrepreneurs.jpg?alt=media&token=fa3f40ab-679e-4286-a4c0-339f5a33f6c1">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Thehomeentrepreneurs-Banner.jpg?alt=media&token=a5a9e9b5-17cb-45dc-b16c-60103827c2c4" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>The Home Entrepreneurs</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div>

    <div class="list-item-port" data-post-id="11181" data-has-img="true"> 
        <div class="inner">
            <div class="port-images-d">
                <div class="nectar-post-grid-item-bg-wrap-inner img-loaded">
                    <a class="bg-wrap-link" aria-label="SaaS" href="#"></a>
                    <img width="377" height="719" class="nectar-lazy nectar-post-grid-item__overlaid-img loaded" alt="" style="" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Vitalprintpress.jpg?alt=media&token=72248b48-1e57-40e8-994f-0b4feed7aed6">
                    <div class="nectar-post-grid-item-bg img-loaded">
                        <img class="nectar-lazy skip-lazy loaded" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Vitalprintpress-Banner.jpg?alt=media&token=4c1cd940-79fa-422d-8d78-d73fd51dc466" alt="" height="871" width="1300" sizes="(max-width: 1300px) 100vw, 1300px" style="" >
                    </div>
                </div>
            </div>
            <div class="content">
                <a class="nectar-post-grid-link" href="#" aria-label="SaaS"></a>
                <div class="item-main">
                    <h3 class="post-heading"><a href="#"><span>Vital Printing Services MPLS</span></a>
                    </h3>
                </div>
                <span class="meta-category">
                    <a class="business" href="#">Business</a>
                </span>
            </div>
        </div>
    </div> -->
</div>